import AdminLayout from "./layouts/AdminLayout/AdminLayout";
import AuthLayout from "./layouts/AuthLayout/AuthLayout";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./layouts/ProtectedRoute";
import { useContext } from "react";
import { AppContext } from "./context/AppContextProvider";
import { LicenseManager } from "@ag-grid-enterprise/core";
import "./App.css";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";

// Retrieve the AG Grid license key from the environment variables
let HAQT_AG_GRID_LICENSE_KEY = process.env.REACT_APP_AG_GRID_LICENCE_KEY;
// Set the AG Grid license key using the LicenseManager
LicenseManager.setLicenseKey(HAQT_AG_GRID_LICENSE_KEY);

const App = () => {
  const { user } = useContext(AppContext);
  const isAuthenticated = Object.keys(user).length > 0 ? true : false;
  return (
    <Routes>
      <Route
        path="/"
        element={isAuthenticated ? <AdminLayout /> : <AuthLayout />}
      />
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <AdminLayout />
          </ProtectedRoute>
        }
      />
      <Route path="/auth/*" element={<AuthLayout />} />
    </Routes>
  );
};

export default App;
